import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		icon: {
			padding: 3,
			right: 5,
		},
		selectMenu: {
			minHeight: 40,
			display: "flex",
			alignItems: "center",
			marginTop: 0,
			paddingTop: 0,
			paddingBottom: 0,
		},
		selectMenuMultiple: {
			height: 'auto !important',
			minHeight: 24,
			maxHeight: 80,
			overflowY: 'auto',
			marginTop: -5,
			paddingTop: 8,
			paddingBottom: 8,
			display: 'flex',
			alignItems: 'flex-start',
		},
		text: {
			marginLeft: 10,
			marginRight: 6,
		},
		checkbox: {
			marginRight: 15,
		},
		listItem: {
			paddingLeft: 15,
		},
		menuItemSelected: {
			backgroundColor: "unset !important",
		},
		outlinedLabel: {
			backgroundColor: "transparent",
			padding: "0 4px",
		},
	} satisfies Record<string, CSSObject>);
};
